import {
  VabsFindPaymentsInput,
  VabsPaymentDirection,
  VabsPaymentStatus,
  requestsClient,
} from '@/shared/api';

interface ITransactionsQueryParams {
  skip?: number;
  search?: string;
  limit?: number;
}

export interface ITxFilters {
  currencyIds?: string[];
  dateRange?: { from: string; to: string };
  directions?: VabsPaymentDirection[];
  statuses?: VabsPaymentStatus[];
}

export const transactionsQuery = async ({
  skip,
  search,
  limit,
  currencyIds,
  dateRange,
  directions,
}: ITransactionsQueryParams & ITxFilters) => {
  const input: VabsFindPaymentsInput = {
    pagination: { limit, skip },
  };

  if (search?.trim()) input.search = search;
  if (currencyIds?.length) input.currencyIds = currencyIds;
  if (dateRange) input.dateRange = dateRange;
  if (directions?.length) input.directions = directions;

  const { vabsMyPayments } = await requestsClient.vabsMyPayments({ input });

  return vabsMyPayments;
};
